import IErrorInfo from "../models/account/IErrorInfo";
import IAuction, {
    IGetAuctions,
    IUpdateAuction
} from "../models/auction/IAuction";
import IAuctionDetail from "../models/auction/IAuctionDetail";
import { IAuctionWatcher } from "../models/auction/IAuctionWatcher";
import ISavedSearchSend from "../models/savedSearchSend/ISavedSearchSend";
import { apiSlice } from "./apiSlice";

const ROUTE = "/auction";

const auctionApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAuctions: builder.query<IAuction[], IGetAuctions>({
            query: ({ includeDrafts, includeTestAuctions }) => ({
                url: `${ROUTE}/get-auctions`,
                params: { includeDrafts, includeTestAuctions }
            })
        }),
        getAuctionByUrl: builder.query<IAuctionDetail, string>({
            query: (url) => `/auction/get-auction?url=${url}`
        }),
        getAuctionWatchers: builder.query<IAuctionWatcher[], string>({
            query: (auctionId) => ({
                url: `${ROUTE}/${auctionId}/watcher`,
                method: "GET"
            })
        }),
        updateAuction: builder.mutation<IErrorInfo[], IUpdateAuction>({
            query: ({ auctionId, patch }) => ({
                url: `${ROUTE}/update/${auctionId}`,
                method: "PATCH",
                headers: { "Content-Type": "application/json-patch+json" },
                body: patch
            })
        }),
        upsertAuctionWatcher: builder.mutation<IErrorInfo[], string>({
            query: (auctionId) => ({
                url: `${ROUTE}/${auctionId}/watcher`,
                method: "POST"
            })
        }),
        getManySavedSearchSends: builder.query<ISavedSearchSend[], string>({
            query: (auctionId) => `${ROUTE}/${auctionId}/saved-search-send`
        }),
        publishAuctions: builder.mutation<void, void>({
            query: () => ({ url: `${ROUTE}/publish`, method: "POST" })
        })
    })
});

export const {
    useGetAuctionsQuery,
    useGetAuctionByUrlQuery,
    useGetAuctionWatchersQuery,
    useGetManySavedSearchSendsQuery,
    usePublishAuctionsMutation,
    useUpdateAuctionMutation,
    useUpsertAuctionWatcherMutation
} = auctionApiSlice;
